import React from 'react';

import type { WidgetReference } from '../types/Widget';

export type StarsWidgetContextValue = WidgetReference;

const StarsWidgetContext = React.createContext<StarsWidgetContextValue | undefined>(undefined);

export default StarsWidgetContext;
